module.exports = __webpack_public_path__ + "images/volkswagenleasing622a2457178f483ffeab7e89948f6584.png";